import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
    private translate: TranslateService = inject(TranslateService);
    private destroyRef: DestroyRef = inject(DestroyRef);

    private OF_LABEL = 'of';
    public override itemsPerPageLabel: string;
    public override nextPageLabel: string;
    public override previousPageLabel: string;

    constructor() {
        super();
        this.translate.onLangChange
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                tap(() => this.getAndInitTranslations())
            )
            .subscribe();
        this.getAndInitTranslations();
    }

    protected getAndInitTranslations(): void {
        this.translate
            .get(['paginator.items-per-page', 'paginator.next-page', 'paginator.previous-page', 'paginator.of-label'])
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                tap((translation) => {
                    this.itemsPerPageLabel = translation['paginator.items-per-page'];
                    this.nextPageLabel = translation['paginator.next-page'];
                    this.previousPageLabel = translation['paginator.previous-page'];
                    this.OF_LABEL = translation['paginator.of-label'];
                    this.changes.next();
                })
            )
            .subscribe();
    }

    public override getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0 || pageSize === 0) {
            return `0 ${this.OF_LABEL} ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} ${this.OF_LABEL} ${length}`;
    };
}
